export default {
  setLoadingQualifications(state) {
    state.list.loading = !state.list.loading
  },
  setQualificationsData(state, payload) {
    state.list.data = payload
  }
}
